import axios from 'axios';

axios.defaults.withCredentials = true;

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    timeout: 60000
});

request.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject(error);
    }
);

request.interceptors.response.use(
    response => {
        return response.data;
    },
    async error => {
        if (!error.response) {
            console.log(error.message, 'Servera bağlantı sırasında bir hata meydana geldi.');
            return Promise.reject(error);
        }
        const status = error.response.status;
        if (status >= 500) {
            console.log('Sunucuda bir hata meydana geldi.');
        } else if (status === 401) {
            console.log('Giriş hatası');
        } else if (status === 403) {
            console.log('Yetki hatası');
        } else {
            console.log(error.message, 'Bilinmeyen bir hata');
        }
        return Promise.reject(error);
    }
);

export default request;
